module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/965ea130b37b735c280e194c78001464.png";